import {
  FormFlex,
  FormFlexDiv,
  TabContainer,
  TabContent,
  TabContentWrapper,
  SmallHeader,
} from "../../pages/Dashboard/styles/dashboard.style";
import { InputWrapper } from "../../pages/auth/Login.style";
import { useMediaQuery } from "react-responsive";
import DatePickerComponent from "../datepicker/DatePicker";
import colors from "../../assets/colors.json";
import FormLoader from "../FormLoader";
import moment from "moment/moment";
import { useCallback, useEffect, useState } from "react";
import { createExperience, deleteExperience, getExperience } from "../../services/user";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
const Experience = ({ status }) => {
  const isTab = useMediaQuery({ maxWidth: 992 });
  const isNumber = (evt) => {
    // console.log(evt);
    evt = evt ? evt : window.event;
    var charCode = evt.which ? evt.which : evt.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 46) {
      evt.preventDefault();
    } else {
      return true;
    }
  };

  const [loadingExp, setLoadingExp] = useState(false);
  const [loadingUploading, setLoadingUploading] = useState(false);
  const [loadingDeleting, setLoadingDeleting] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [editingItem, setEditingItem] = useState(null);
  const { user, admToken, } = useSelector((state) => state.auth);
  const [data, setData] = useState(null);
  const [form, setForm] = useState({
    employer: '',
    position: '',
    empPhoneNumber: '',
    empEmail: '',
    empAddress: '',
    startDate: null,
    endDate: null,
    reasons: '',
    id: 0
  });

  const getUserExperience = useCallback(async () => {
    try {
      setLoadingExp(true)
      const res = await getExperience(admToken, user?.staffId);
      console.log(res);
      if (res.status && res.statusCode === 2) {
        setData(res.data);
      } else {
        setData(null);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoadingExp(false)
    }
  }, [admToken, user?.staffId]);

  useEffect(() => {
    getUserExperience();
  }, [user?.staffId])

  const handleUpdate = async () => {
    try {
      const payload = {
        employer: form.employer,
        position: form.position,
        empPhoneNumber: form.empPhoneNumber,
        empEmail: form.empEmail,
        empAddress: form.empAddress,
        startDate: form.startDate,
        endDate: form.endDate,
        reasons: form.reasons,
        id: form.id || 0
      };
      setLoadingUploading(true)
      const res = await createExperience(admToken, payload, user?.staffId);
      if (res.status && res.statusCode === 2) {
        toast.success(res.message);
        setForm({
          employer: '',
          position: '',
          empPhoneNumber: '',
          empEmail: '',
          empAddress: '',
          startDate: null,
          endDate: null,
          reasons: '',
          id: 0
        })
        setShowModal(false);
        setEditingItem(null);
        getUserExperience();
      } else {
        toast.error(res.message);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoadingUploading(false)
    }
  };

  const handleDelete = async (id) => {
    try {
      setLoadingDeleting(id)
      const res = await deleteExperience(admToken, id);
      if (res.status && res.statusCode === 2) {
        toast.success(res.message);
        getUserExperience();
      } else {
        toast.error(res.message);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoadingDeleting(null)
    }
  };

  const handleOpenEdit = (item) => {
    setEditingItem(item);
    setForm({
      employer: item.employer,
      position: item.position,
      empPhoneNumber: item.empPhoneNumber,
      empEmail: item.empEmail,
      empAddress: item.empAddress,
      startDate: item.startDate ? new Date(item.startDate).toISOString() : null,
      endDate: item.endDate ? new Date(item.endDate).toISOString() : null,
      reasons: item.reasons,
      id: item.id,
      current: !item.endDate,
    });
    setShowModal(true);
  };

  return (
    <TabContentWrapper>
      <>
        <FormFlex>
          <FormFlexDiv>
            <InputWrapper>
              <label htmlFor="employer">Employer</label>
              <input
                type="text"
                placeholder="Employer"
                value={form.employer}
                onChange={(e) => setForm({ ...form, employer: e.target.value })}
                disabled={!(status === 0 || status === 4) || loadingExp}
              />
            </InputWrapper>
            <InputWrapper>
              <label htmlFor="empolyer">Employer's phone Number</label>
              <input
                type="text"
                onKeyDown={(e) => isNumber(e)}
                placeholder="Employer's Phone Number"
                value={form.empPhoneNumber}
                onChange={(e) =>
                  setForm({ ...form, empPhoneNumber: e.target.value })
                }
                disabled={!(status === 0 || status === 4) || loadingExp}
              />
            </InputWrapper>
          </FormFlexDiv>
          <FormFlexDiv>
            <InputWrapper>
              <label htmlFor="">Position</label>
              <input
                type="text"
                placeholder="Position"
                value={form.position}
                onChange={(e) => setForm({ ...form, position: e.target.value })}
                disabled={!(status === 0 || status === 4) || loadingExp}
              />
            </InputWrapper>
            <InputWrapper>
              <label htmlFor="">Employer's Email</label>
              <input
                type="text"
                placeholder="Employer's Email"
                value={form.empEmail}
                onChange={(e) => setForm({ ...form, empEmail: e.target.value })}
                disabled={!(status === 0 || status === 4) || loadingExp}
              />
            </InputWrapper>
          </FormFlexDiv>
        </FormFlex>
        <FormFlex>
          <FormFlexDiv>
            <InputWrapper>
              <label htmlFor="employer's address">Employer's Address</label>
              <textarea
                cols="30"
                rows="3"
                placeholder="Employer's Address"
                value={form.empAddress}
                onChange={(e) =>
                  setForm({ ...form, empAddress: e.target.value })
                }
                disabled={!(status === 0 || status === 4) || loadingExp}
              ></textarea>
            </InputWrapper>
          </FormFlexDiv>
          <FormFlexDiv>
            <InputWrapper>
              <label htmlFor="">Reason For Leaving</label>
              <textarea
                cols="30"
                rows="3"
                placeholder="Reason For Leaving"
                value={form.reasons}
                onChange={(e) => setForm({ ...form, reasons: e.target.value })}
                disabled={!(status === 0 || status === 4) || loadingExp}
              ></textarea>
            </InputWrapper>
          </FormFlexDiv>
        </FormFlex>
        <FormFlex>
          <FormFlexDiv>
            <InputWrapper>
              <label htmlFor="">Start Date</label>
              <DatePickerComponent
                selected={form.startDate ? new Date(form.startDate) : null}
                setSelected={(val) => setForm({ ...form, startDate: val ? val.toISOString() : null })}
                disabled={!(status === 0 || status === 4) || loadingExp}
              />
            </InputWrapper>

            <div
              style={{
                display: "inline-flex",
                width: "100%",
                alignItems: "center",
                marginTop: "10px",
              }}
            >
              <div style={{ width: "fit-content", marginRight: "10px" }}>
                <input
                  type="checkbox"
                  checked={form.current}
                  onChange={(e) =>
                    e.target.checked
                      ? setForm({ ...form, current: true })
                      : setForm({ ...form, current: false })
                  }
                  // value={form.current}
                  // onChange={}
                  style={{
                    padding: "0.2rem 0.4rem",
                    width: "min-content",
                    marginTop: "0px",
                  }}
                  disabled={!(status === 0 || status === 4) || loadingExp}
                />
              </div>
              <div style={{ width: "-webkit-fill-available" }}>
                <label htmlFor="">I Currently Work Here</label>
              </div>
            </div>
          </FormFlexDiv>
          {!form.current && (
            <FormFlexDiv>
              <InputWrapper>
                <label htmlFor="">End Date</label>
                <DatePickerComponent
                  selected={form.endDate ? new Date(form.endDate) : null}
                  setSelected={(val) => setForm({ ...form, endDate: val ? val.toISOString() : null })}
                  disabled={!(status === 0 || status === 4) || loadingExp}
                />
              </InputWrapper>
            </FormFlexDiv>
          )}
        </FormFlex>
        {/* {status === 4 && ( */}
          <div className="flex items-center justify-end my-5">
            <button
              disabled={loadingUploading}
              onClick={handleUpdate}
              className="px-8 py-2.5 rounded-lg text-white bg-primary disabled:cursor-not-allowed disabled:bg-gray-300"
            >
              {loadingUploading ? "Adding..." : "Add"}
            </button>
          </div>
        {/* )} */}
      </>

      <TabContainer style={{ marginTop: "30px", borderRadius: "10px", padding: "0.5rem 0.8rem", }}>
        {loadingExp ?
          <div className="flex justify-center items-center h-20"><FormLoader /></div>
          :
          data?.length > 0 ? (
            data?.map((item, index) => (
              <TabContainer style={{ borderRadius: "10px" }} key={index}>
                <div
                  style={{
                    width: "100%",
                    padding: "0.5rem 0.8rem",
                    backgroundColor: colors.secondary,
                    borderTopLeftRadius: "10px",
                    borderTopRightRadius: "10px",
                    display: "inline-flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <div
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                    }}
                  >
                    <div
                      style={{
                        height: "5px",
                        width: "5px",
                        padding: "5px",
                        borderRadius: "50%",
                        backgroundColor: colors.primary,
                        marginRight: "9px",
                      }}
                    ></div>
                    <div>
                      <p style={{ fontSize: "16px", fontWeight: "bold" }}>
                        {item.position}
                      </p>
                      <p
                        style={{
                          fontSize: "14px",
                          marginTop: "5px",
                          fontWeight: "semibold",
                        }}
                      >
                        {item.employer} - <span>{item.empAddress}</span>
                      </p>
                      <p
                        style={{
                          fontSize: "14px",
                          marginTop: "5px",
                          fontWeight: "semibold",
                        }}
                      >
                        {`${moment(item.startDate).format("MMMM YYYY")} -${moment(
                          item.endDate
                        ).format("MMMM YYYY")}`}
                      </p>
                    </div>
                  </div>
                  <div className="flex items-center gap-8">
                    <button
                      disabled={!(status === 0 || status === 4) || loadingExp || loadingUploading}
                      style={{
                        borderWidth: "1px",
                        borderRadius: "5px",
                        borderColor: colors.primary,
                        color: "black",
                        padding: "10px 20px",
                        backgroundColor: "transparent",
                        fontWeight: "bold",
                      }}
                      onClick={() => handleOpenEdit(item)}
                    >
                      Edit
                    </button>
                    <button
                      disabled={!(status === 0 || status === 4) || loadingExp || loadingDeleting}
                      style={{
                        borderWidth: "1px",
                        borderRadius: "5px",
                        borderColor: colors.primary,
                        color: "black",
                        padding: "10px 20px",
                        backgroundColor: "transparent",
                        fontWeight: "bold",
                      }}
                      onClick={() => handleDelete(item.id)}
                    >
                      {loadingDeleting ? "Deleting.." : "Delete"}
                    </button>
                  </div>
                </div>
                <TabContent>
                  <TabContentWrapper>
                    <div
                      style={{
                        padding: "0.3rem 0.6rem",
                      }}
                    >
                      <p>{item.reasons}</p>
                    </div>
                  </TabContentWrapper>
                </TabContent>
              </TabContainer>
            ))
          ) : (
            <>
              <SmallHeader style={{ textAlign: "center", fontWeight: "bold" }}>
                No Work Experience From Staff
              </SmallHeader>
            </>
          )}
      </TabContainer>
      {showModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center"
          style={{ zIndex: 1400 }}
        >
          <div className="bg-white rounded-lg p-6 w-[600px] max-w-full">

            <h2 className="text-xl font-bold mb-4">Edit Experience</h2>

            <FormFlex>
              <FormFlexDiv>
                <InputWrapper>
                  <label htmlFor="employer">Employer</label>
                  <input
                    type="text"
                    placeholder="Employer"
                    value={form.employer}
                    onChange={(e) => setForm({ ...form, employer: e.target.value })}
                    disabled={!(status === 0 || status === 4) || loadingExp}
                  />
                </InputWrapper>
                <InputWrapper>
                  <label htmlFor="empolyer">Employer's phone Number</label>
                  <input
                    type="text"
                    onKeyDown={(e) => isNumber(e)}
                    placeholder="Employer's Phone Number"
                    value={form.empPhoneNumber}
                    onChange={(e) =>
                      setForm({ ...form, empPhoneNumber: e.target.value })
                    }
                    disabled={!(status === 0 || status === 4) || loadingExp}
                  />
                </InputWrapper>
              </FormFlexDiv>
              <FormFlexDiv>
                <InputWrapper>
                  <label htmlFor="">Position</label>
                  <input
                    type="text"
                    placeholder="Position"
                    value={form.position}
                    onChange={(e) => setForm({ ...form, position: e.target.value })}
                    disabled={!(status === 0 || status === 4) || loadingExp}
                  />
                </InputWrapper>
                <InputWrapper>
                  <label htmlFor="">Employer's Email</label>
                  <input
                    type="text"
                    placeholder="Employer's Email"
                    value={form.empEmail}
                    onChange={(e) => setForm({ ...form, empEmail: e.target.value })}
                    disabled={!(status === 0 || status === 4) || loadingExp}
                  />
                </InputWrapper>
              </FormFlexDiv>
            </FormFlex>
            <FormFlex>
              <FormFlexDiv>
                <InputWrapper>
                  <label htmlFor="employer's address">Employer's Address</label>
                  <textarea
                    cols="30"
                    rows="3"
                    placeholder="Employer's Address"
                    value={form.empAddress}
                    onChange={(e) =>
                      setForm({ ...form, empAddress: e.target.value })
                    }
                    disabled={!(status === 0 || status === 4) || loadingExp}
                  ></textarea>
                </InputWrapper>
              </FormFlexDiv>
              <FormFlexDiv>
                <InputWrapper>
                  <label htmlFor="">Reason For Leaving</label>
                  <textarea
                    cols="30"
                    rows="3"
                    placeholder="Reason For Leaving"
                    value={form.reasons}
                    onChange={(e) => setForm({ ...form, reasons: e.target.value })}
                    disabled={!(status === 0 || status === 4) || loadingExp}
                  ></textarea>
                </InputWrapper>
              </FormFlexDiv>
            </FormFlex>
            <FormFlex>
              <FormFlexDiv>
                <InputWrapper>
                  <label htmlFor="">Start Date</label>
                  <DatePickerComponent
                    selected={form.startDate ? new Date(form.startDate) : null}
                    setSelected={(val) => setForm({ ...form, startDate: val ? val.toISOString() : null })}
                    disabled={!(status === 0 || status === 4) || loadingExp}
                  />
                </InputWrapper>

                <div
                  style={{
                    display: "inline-flex",
                    width: "100%",
                    alignItems: "center",
                    marginTop: "10px",
                  }}
                >
                  <div style={{ width: "fit-content", marginRight: "10px" }}>
                    <input
                      type="checkbox"
                      checked={form.current}
                      onChange={(e) =>
                        e.target.checked
                          ? setForm({ ...form, current: true })
                          : setForm({ ...form, current: false })
                      }
                      // value={form.current}
                      // onChange={}
                      style={{
                        padding: "0.2rem 0.4rem",
                        width: "min-content",
                        marginTop: "0px",
                      }}
                      disabled={!(status === 0 || status === 4) || loadingExp}
                    />
                  </div>
                  <div style={{ width: "-webkit-fill-available" }}>
                    <label htmlFor="">I Currently Work Here</label>
                  </div>
                </div>
              </FormFlexDiv>
              {!form.current && (
                <FormFlexDiv>
                  <InputWrapper>
                    <label htmlFor="">End Date</label>
                    <DatePickerComponent
                      selected={form.endDate ? new Date(form.endDate) : null}
                      setSelected={(val) => setForm({ ...form, endDate: val ? val.toISOString() : null })}
                      disabled={!(status === 0 || status === 4) || loadingExp}
                    />
                  </InputWrapper>
                </FormFlexDiv>
              )}
            </FormFlex>

            <div className="flex justify-end gap-4 mt-6">
              <button
                onClick={() => setShowModal(false)}
                className="py-2 px-4 bg-gray-300 rounded-md"
              >
                Cancel
              </button>

              <button
                onClick={handleUpdate}
                disabled={loadingUploading}
                className="py-2 px-6 bg-primary text-white rounded-md"
              >
                {loadingUploading ? "Updating..." : "Save Changes"}
              </button>
            </div>

          </div>
        </div>
      )}

    </TabContentWrapper>
  );
};

export default Experience;
